"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const cosmos_1 = require("components/cosmos");
const tooltip_1 = __importDefault(require("components/cosmos/tooltip"));
const translationContext_1 = require("configs/translationContext");
const mobx_react_1 = require("mobx-react");
const mapStateToProps = (stores) => ({
    classesForDripping: stores.DrippingStore.classesForDripping,
    drippings: stores.DrippingStore.items
});
const CreateNewDripping = ({ classesForDripping, drippings, onClick }) => {
    const { t } = (0, translationContext_1.useTranslation)();
    const hasDrippingAllClass = drippings.some((item) => item.allClasses);
    const hasNotAvailableClassesIds = (0, react_1.useMemo)(() => {
        const classesForDrippingIds = classesForDripping.map(({ id }) => id);
        const classesBeingUsedIds = drippings.flatMap((item) => item.classes.map(({ hashId }) => hashId));
        const availableClassesIds = classesForDrippingIds.filter((item) => !classesBeingUsedIds.includes(item));
        return (drippings.length > 0 &&
            classesBeingUsedIds.length > 0 &&
            availableClassesIds.length === 0);
    }, [classesForDripping, drippings]);
    const isButtonDisabled = hasDrippingAllClass || hasNotAvailableClassesIds;
    return ((0, jsx_runtime_1.jsx)(tooltip_1.default, { position: tooltip_1.default.TOOLTIP_POSITION.TOP, ...(isButtonDisabled && {
            content: t('dripping_2.notifications.all_classes_already_have_appointments')
        }), children: (0, jsx_runtime_1.jsx)(cosmos_1.Button, { variation: "default", className: "_w-full _w-sm-auto _bg-gray-600 _text-gray-100 _text-1 _py-1 _px-2", icon: ['fal', 'plus'], disabled: isButtonDisabled, onClick: onClick, type: "button", children: t('dripping_2.actions.new') }) }));
};
exports.default = (0, mobx_react_1.inject)(mapStateToProps)(CreateNewDripping);
